interface ProgressBarProps {
  processedCount: number;
  needsProcessingCount: number;
  label?: string;
}

export function ProgressBar({ processedCount, needsProcessingCount, label = "Processing..." }: ProgressBarProps) {
  // Clamp to [0, 100] so legacy counter drift (processed_count > needs_processing_count,
  // possible on batches that lived through historical bugs) can never render as e.g. 325%.
  const rawProgress = needsProcessingCount > 0
    ? Math.round((processedCount / needsProcessingCount) * 100)
    : 0;
  const progress = Math.min(100, Math.max(0, rawProgress));

  return (
    <div className="mt-4">
      <div className="flex justify-between text-sm text-gray-600 mb-2">
        <span>{label}</span>
        <span>{progress}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-3">
        <div
          className="bg-blue-600 h-3 rounded-full transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
